import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0df7bb30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-col-12 p-md-8 p-pt-2",
  style: {"height":"100%"}
}
const _hoisted_2 = {
  key: 2,
  style: {"width":"fit-content"},
  class: "p-m-1"
}
const _hoisted_3 = { class: "p-mt-2 p-error p-text-center" }

import { computed, defineAsyncComponent, watch } from "vue";
import Ticket from "@/components/pos/Ticket.vue";
import { useActiveSequence } from "@/graphql/sequence/active.sequence";
import { useTicketTable } from "@/graphql/ticket/create.ticket";
import { useWHoAmI } from "@/graphql/user/whoAmi";
import { changeStyle, MenuSettings } from "@/layouts/workspace/menu-settings";
import { subscriptionExpired } from "@/plugins/i18n";
import { useRemoveTicket } from "@/graphql/ticket/remove.ticket";
import ExpirationDialog from "@/components/common/ExpirationDialog.vue";
import { useProducts } from "@/graphql/product/products";
import ZoomScreen from "@/components/common/ZoomScreen.vue";
import { useI18n } from "vue-i18n";
import { useConfirm } from "primevue/useconfirm";
import TerminalGuard from "@/components/pos/TerminalGuard.vue";
import { canNavigateAnywhere, getFirstReadAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'POS',
  setup(__props) {

const CodeFinder = defineAsyncComponent(
  () => import("@/components/pos/CodeFinder.vue")
);
const PosProduct = defineAsyncComponent(
  () => import("@/components/pos/PosProduct.vue")
);
const ExpenseTable = defineAsyncComponent(
  () => import("@/components/expense/ExpenseTable.vue")
);
const CreditTicket = defineAsyncComponent(
  () => import("@/components/pos/CreditTicket.vue")
);
const TicketList = defineAsyncComponent(
  () => import("@/components/pos/WaitingTicket.vue")
);
const PosRapport = defineAsyncComponent(
  () => import("@/components/pos/PosRapport.vue")
);

const { t } = useI18n();
const confirm = useConfirm();
const { Iam } = useWHoAmI();

const { loading, products } = useProducts();

const {
  asLoading,
  seqItems,
  active,
  menuItems,
  selectedTicket,
  csLoading,
  tickets,
  menu,
  terminal,
  ticketInfos,
} = useActiveSequence(() => (menu.value = "sale"));

const {
  ticketRows,
  addToTicketRow,
  removeTicketRow,
  onTicketSelect,
  onModifyOrRecover,
} = useTicketTable();

watch(
  () => Iam.value,
  (me) => {
    if (me) {
      const { changeStyleSheetUrl } = changeStyle();
      const scheme = MenuSettings.colorSchemes[me.settings[1]];
      changeStyleSheetUrl("layout-css", "layout-" + scheme + ".css", 1);
      changeStyleSheetUrl("theme-css", "theme-" + scheme + ".css", 1);
    }
  },
  { immediate: true }
);

function onRecovered() {
  selectedTicket.value.length = 0;
  menu.value = "sale";
  onModifyOrRecover();
}

const disableRemove = computed(() => {
  const alreadyRemoved = [4, 5].includes(selectedTicket.value[0]?.status);
  const creditOfCurrentSeq =
    selectedTicket.value[0]?.status === 1 &&
    active.value.sequence?.id !== selectedTicket.value[0]?.sequenceId;

  return alreadyRemoved || creditOfCurrentSeq;
});

function onCloseSequence() {
  ticketRows.value.length = 0;
  selectedTicket.value.length = 0;
  menu.value = "sale";
}

function onMenuClick(men: string) {
  if (menu.value !== "sale" && men === "sale" && selectedTicket.value.length) {
    ticketRows.value.length = 0;
    selectedTicket.value.length = 0;
  }
  //if (men !== "sequence") this.sequenceRapport = null;
  menu.value = men;
}

const { removeTicketLoading, removeTicket, modifyTicket, isModification } =
  useRemoveTicket((modification: boolean) => {
    if (modification) {
      menu.value = "sale";
      onModifyOrRecover();
    } else ticketRows.value.length = 0;
    selectedTicket.value.length = 0;
  });

function onRemoveTicket(freeTerminal: boolean) {
  if (disableRemove.value) return;
  if (selectedTicket.value.length && freeTerminal) {
    removeTicket(selectedTicket.value[0].id, active.value.sequence.id);
  } else if (ticketRows.value.length) {
    isModification.value = false;
    confirm.require({
      header: t("delete.title"),
      message: t("delete.confirm"),
      group: "dialog",
      accept: () => (ticketRows.value.length = 0),
      icon: "pi pi-exclamation-triangle",
      rejectLabel: t("no"),
      acceptLabel: t("yes"),
      acceptClass: "p-button-warning",
    });
  }
}

function onModify() {
  confirm.require({
    header: t("delete.title"),
    message: t("ticket.update.warning"),
    group: "dialog",
    accept: () => {
      onTicketSelect(selectedTicket.value[0].movements);
      modifyTicket(selectedTicket.value[0].id, active.value.sequence.id);
    },
    icon: "pi pi-exclamation-triangle",
    rejectLabel: t("cancel"),
    acceptLabel: t("confirm"),
    acceptClass: "p-button-warning",
  });
}

const getHome = () => {
  const path = getFirstReadAccess(undefined, canNavigateAnywhere());
  return `/workspace/${path}`;
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _directive_badge = _resolveDirective("badge")!

  return (!!_unref(Iam).id)
    ? (_openBlock(), _createBlock(TerminalGuard, {
        key: 0,
        id: "container",
        "current-user": _unref(Iam).id
      }, {
        default: _withCtx(({ freeTerminal }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Menubar, {
              class: "p-mb-1",
              model: _unref(menuItems)
            }, {
              start: _withCtx(() => [
                _createVNode(_component_Button, {
                  loading: _unref(loading),
                  icon: "pi pi-home",
                  class: "menu-button p-button-warning",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(getHome())))
                }, null, 8, ["loading"])
              ]),
              item: _withCtx(({ item }) => [
                (item.label === 'sale')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: item.icon,
                      label: _ctx.$t(`pos.${item.label}`),
                      class: _normalizeClass(["menu-button p-mr-1 p-button-secondary", { 'p-button-success': _unref(menu) === item.label }]),
                      onClick: ($event: any) => (onMenuClick(item.label))
                    }, null, 8, ["icon", "label", "class", "onClick"]))
                  : (item.label === 'sequence')
                    ? (_openBlock(), _createBlock(_component_SplitButton, {
                        key: 1,
                        label: _ctx.$t(`pos.${item.label}`),
                        disabled: _unref(asLoading) || _unref(csLoading),
                        icon: _unref(asLoading) || _unref(csLoading) ? 'pi pi-spinner' : item.icon,
                        model: _unref(seqItems),
                        class: _normalizeClass(["menu-button p-m-1 p-button-secondary", { 'p-button-success': _unref(menu) === item.label }])
                      }, null, 8, ["label", "disabled", "icon", "model", "class"]))
                    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_Button, {
                          icon: item.icon,
                          label: _ctx.$t(`pos.${item.label}`),
                          class: _normalizeClass(["menu-button p-button-secondary", { 'p-button-success': _unref(menu) === item.label }]),
                          onClick: ($event: any) => (onMenuClick(`${item.label}`))
                        }, null, 8, ["icon", "label", "class", "onClick"])
                      ])), [
                        [
                          _directive_badge,
                          `${item.badge}`,
                          void 0,
                          { danger: true }
                        ]
                      ])
              ]),
              end: _withCtx(() => [
                _createVNode(ZoomScreen, { class: "p-ml-2" })
              ]),
              _: 1
            }, 8, ["model"]),
            (_unref(menu) === 'expense')
              ? (_openBlock(), _createBlock(_unref(ExpenseTable), {
                  key: 0,
                  sequenceId: _unref(active)?.sequence?.id,
                  items: _unref(active)?.sequence?.expenses
                }, null, 8, ["sequenceId", "items"]))
              : (_unref(menu) === 'sale')
                ? (_openBlock(), _createBlock(_unref(PosProduct), {
                    key: 1,
                    onAddToTicketRow: _unref(addToTicketRow),
                    hasSequence: !!_unref(active)?.sequence?.id,
                    categories: _unref(terminal)?.categories || [],
                    products: _unref(products)
                  }, null, 8, ["onAddToTicketRow", "hasSequence", "categories", "products"]))
                : (_unref(menu) === 'credit')
                  ? (_openBlock(), _createBlock(_unref(CreditTicket), {
                      key: 2,
                      tickets: _unref(tickets).credit,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_unref(onTicketSelect)($event[0].movements))),
                        _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedTicket) ? (selectedTicket).value = $event : null))
                      ],
                      modelValue: _unref(selectedTicket)
                    }, null, 8, ["tickets", "modelValue"]))
                  : (_unref(menu) === 'waiting')
                    ? (_openBlock(), _createBlock(_unref(TicketList), {
                        key: 3,
                        tickets: _unref(tickets).waiting,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => (_unref(onTicketSelect)($event[0].movements))),
                          _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedTicket) ? (selectedTicket).value = $event : null))
                        ],
                        modelValue: _unref(selectedTicket)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("ticket.waitingList")), 1)
                        ]),
                        _: 1
                      }, 8, ["tickets", "modelValue"]))
                    : (_unref(menu) === 'ticket')
                      ? (_openBlock(), _createBlock(_unref(TicketList), {
                          key: 4,
                          tickets: _unref(tickets).sales,
                          "onUpdate:modelValue": [
                            _cache[5] || (_cache[5] = ($event: any) => (_unref(onTicketSelect)($event[0].movements))),
                            _cache[6] || (_cache[6] = ($event: any) => (_isRef(selectedTicket) ? (selectedTicket).value = $event : null))
                          ],
                          modelValue: _unref(selectedTicket)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("ticket.salesList")), 1)
                          ]),
                          _: 1
                        }, 8, ["tickets", "modelValue"]))
                      : (_openBlock(), _createBlock(_unref(PosRapport), {
                          key: 5,
                          sequence: _unref(active)?.sequence,
                          waitingNumber: _unref(menuItems)[2].badge,
                          "free-terminal": freeTerminal,
                          onDone: onCloseSequence
                        }, null, 8, ["sequence", "waitingNumber", "free-terminal"]))
          ]),
          _createVNode(_component_BlockUI, {
            blocked: 
        !_unref(active)?.sequence || _unref(seqItems)[3].disabled || _unref(subscriptionExpired)()
      ,
            class: "p-col-12 p-md-4 p-px-0 p-pb-0",
            style: {"height":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(Ticket, {
                "ticket-rows": _unref(ticketRows),
                "onUpdate:ticketRows": _cache[7] || (_cache[7] = ($event: any) => (_isRef(ticketRows) ? (ticketRows).value = $event : null)),
                "sequence-id": _unref(active)?.sequence?.id,
                "print-barcode": _unref(terminal).printBarcode,
                onRemoveRow: _unref(removeTicketRow),
                freeTerminal: freeTerminal,
                ticket: _unref(selectedTicket),
                "onUpdate:ticket": _cache[8] || (_cache[8] = ($event: any) => (_isRef(selectedTicket) ? (selectedTicket).value = $event : null)),
                onModify: onModify,
                style: {"height":"100%"},
                isModification: _unref(isModification),
                "onUpdate:isModification": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isModification) ? (isModification).value = $event : null)),
                onRecovered: _cache[10] || (_cache[10] = ($event: any) => (onRecovered()))
              }, _createSlots({
                remove: _withCtx(() => [
                  _createVNode(_component_Button, {
                    loading: _unref(removeTicketLoading),
                    onClick: ($event: any) => (onRemoveTicket(freeTerminal)),
                    class: "p-button-danger",
                    icon: "pi pi-trash",
                    disabled: disableRemove.value
                  }, null, 8, ["loading", "onClick", "disabled"])
                ]),
                _: 2
              }, [
                (_unref(ticketInfos))
                  ? {
                      name: "ticket-infos",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(ticketInfos)), 1)
                      ]),
                      key: "0"
                    }
                  : undefined,
                (_unref(terminal).codeBar && !_unref(selectedTicket).length)
                  ? {
                      name: "code-bar",
                      fn: _withCtx(() => [
                        _createVNode(_unref(CodeFinder), {
                          onAddToTicketRow: _unref(addToTicketRow),
                          products: _unref(products),
                          class: "p-col-12"
                        }, null, 8, ["onAddToTicketRow", "products"])
                      ]),
                      key: "1"
                    }
                  : undefined
              ]), 1032, ["ticket-rows", "sequence-id", "print-barcode", "onRemoveRow", "freeTerminal", "ticket", "isModification"])
            ]),
            _: 2
          }, 1032, ["blocked"]),
          _createVNode(ExpirationDialog, { closable: false })
        ]),
        _: 1
      }, 8, ["current-user"]))
    : _createCommentVNode("", true)
}
}

})